import { FtlRoutingViewModel } from "../../../../ViewModel/FtlRoutingViewModel";

export function isRoutingTableChanged(
  routingTable: Array<FtlRoutingViewModel> | undefined,
  templateRoutingTable: Array<FtlRoutingViewModel> | undefined
) {
  if (
    !routingTable ||
    !templateRoutingTable ||
    routingTable.length !== templateRoutingTable.length
  ) {
    return true;
  }

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < routingTable.length; i++) {
    if (
      routingTable[i].PuDoType !== templateRoutingTable[i].PuDoType ||
      routingTable[i].Day !== templateRoutingTable[i].Day ||
      routingTable[i].ETA !== templateRoutingTable[i].ETA ||
      routingTable[i].ETD !== templateRoutingTable[i].ETD ||
      routingTable[i].Km !== templateRoutingTable[i].Km ||
      routingTable[i].DrivingHours !== templateRoutingTable[i].DrivingHours
    ) {
      return true;
    }
  }
  return false;
}
